export const lelekaApplyForm = process.env.REACT_APP_APPLY_FORM;
export const lelekaURL = process.env.REACT_APP_WEBSITE_URL;
export const lelekaPrice = ''//process.env.REACT_APP_PRICE;
